import { render, staticRenderFns } from "./principalProfesiograma.vue?vue&type=template&id=765de92b"
import script from "./principalProfesiograma.vue?vue&type=script&lang=js"
export * from "./principalProfesiograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports